import React, { useState } from "react";
import "./qualification.css";
const Qualifications = () => {
  const [toggleState, setToggleState] = useState(0);
  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="qualification section">
      <h2 className="section__title">Qualificações</h2>
      <span className="section__subtitle">Clique em <b>educação</b> ou <b>experiência</b> para expandir</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-book-reader qualification__icon"></i>
            Educação
          </div>
          <div
            className={
              toggleState === 2
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-briefcase-alt qualification__icon"></i>
            Experiência
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Análise e Desenvolvimento de Sistemas</h3>
                <span className="qualification__subtitle">
                  Faculdade São Miguel
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 03/2018- 06/2021
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">Desenvolvimento Web Fullstack</h3>
                <span className="qualification__subtitle">
                  Trybe
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 10/2020 - 02/2022
                </div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Ignite</h3>
                <span className="qualification__subtitle">
                  Rocketseat
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 2022 - Atualmente
                </div>
              </div>
            <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">
                  Desenvolvedor Web Fullstack
                </h3>
                <span className="qualification__subtitle">
                  Alô Bebê
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 03/2022
                </div>
              </div>
            </div>

           <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  Desenvolvedor Web Fullstack
                </h3>
                <span className="qualification__subtitle">
                  Freelancer
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 02/2021
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            {/*  3º experiência
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">
                 função na empresa 
                </h3>
                <span className="qualification__subtitle">
                  nome da empresa
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> data
                </div>
              </div>
            </div> */}

            {/* 4º experientia
             <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                função na empresa 
                </h3>
                <span className="qualification__subtitle">
                nome da empresa
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> data
                </div>
              </div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>  */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualifications;
